import { Applicant } from 'store/dashboard/types'
import { filterAndSortByPurePlay } from '../sections/chartsSection/purePlaySection/purePlayCalculations'
/**
 * Function to calculate the competitors, by filtering and sorting applicants based on the target company and selected criteria.
 *
 * @param allApplgroupedApplicantsicants
 * @param topCompaniesNumber - Default is 10
 * @param selectedSubgroups - Subgroups selected in first section
 * @param ipWeight - for filtering
 * @returns Array of Applicant objects representing the competitors
 */
export function getMultisectorCompetitors(
  applicants: Applicant[],
  topCompaniesNumber: number,
  subgroupsSelected: string[],
  ipWeight?: number,
) {
  if (applicants.length === 0) {
    return []
  }
  const targetCompany = applicants[0]
  const competitors: Applicant[] = filterAndSortByPurePlay(
    targetCompany,
    applicants,
    topCompaniesNumber,
    subgroupsSelected,
    ipWeight,
  )
  console.log(`useMultisectorCompetitors: Calculated ${competitors.length} competitors`)
  return competitors
}
